import { Input, Textarea } from '@nextui-org/react'
import CreateDropZone from './CreateDropZone'

export default function CompanyFinancial({ formData, handleChange, userUUID }: any) {
  return (
    <div className="flex flex-col gap-4">
      <CreateDropZone
        isRequired
        title="Financial Statements (Last 3 Years)"
        description="Upload audited annual accounts."
        onFilesChange={(files) => handleChange?.('financialStatements', files)}
        userUUID={userUUID}
        files={formData?.financialStatements ?? []}
      />

      <Textarea
        isRequired
        label="Annual Turnover (3 Years)"
        variant="bordered"
        placeholder="Revenue per year."
        value={formData?.annualTurnover}
        onChange={(e) => handleChange?.('annualTurnover', e.target.value)}
      />

      <Input
        isRequired
        label="VAT Number (Umsatzsteuer-ID)"
        placeholder="e.g. DE123456789"
        variant="bordered"
        value={formData?.vatNumber}
        onChange={(e) => handleChange?.('vatNumber', e.target.value)}
      />

      <CreateDropZone
        isRequired
        title="Tax Compliance Certificate"
        description="Recent tax-office clearance letter."
        onFilesChange={(files) => handleChange?.('taxCompliance', files)}
        userUUID={userUUID}
        files={formData?.taxCompliance ?? []}
      />
      <CreateDropZone
        isRequired
        title="Credit Rating / Solvency Proof"
        description="Creditreform, D&B, or bank letter."
        onFilesChange={(files) => handleChange?.('creditRating', files)}
        userUUID={userUUID}
        files={formData?.creditRating ?? []}
      />
      <Textarea
        isRequired
        label=" Bank References or Guarantees"
        variant="bordered"
        placeholder="Details on credit lines/performance bonds."
        value={formData?.bankReferences}
        onChange={(e) => handleChange?.('bankReferences', e.target.value)}
      />
    </div>
  )
}
